import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';

/** A password field with an eye button inside it to show or hide what's typed. */
export function PasswordInput({ className = '', ...props }: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  return (
    <div className="password-field">
      <input {...props} className={`input ${className}`.trim()} type={show ? 'text' : 'password'} />
      <button type="button" className="password-eye" onClick={() => setShow((s) => !s)} aria-label={show ? t('reset.hide') : t('reset.show')} aria-pressed={show} title={show ? t('reset.hide') : t('reset.show')}>
        <Icon name={show ? 'eyeOff' : 'eye'} size={20} />
      </button>
    </div>
  );
}
